import { render, staticRenderFns } from "./MobileHotels.vue?vue&type=template&id=a44f054a&"
import script from "./MobileHotels.vue?vue&type=script&lang=js&"
export * from "./MobileHotels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports